import axios from "axios"

const state = {
    user_auth: false,
    user_name: null,
    user_login: null,
    user_email: null,
    user_access_codes: [],
    payment_systems: [],
    account_details: [],
}

const getters = {
    isAuthenticated: (state)        => state.user_auth,
    StateUserName: (state)          => state.user_name,
    StateUserEmail: (state)         => state.user_email,
    StateUserLogin: (state)         => state.user_login,
    StateUserAccessCodes: (state)   => state.user_access_codes,
    StatePaymentSystems: (state)    => state.payment_systems,
    StateAccountDetails: (state)    => state.account_details,
}

const actions = {
    // Login
    async ActionLogin({ commit, rootState }, user) {
        try {
            let user_result = await axios.post("/api/public/login/", { username: user.login, password: user.password }).then(res => res.data)
            if (user_result && user_result.result && user_result.data) {
                try { await commit("setUser", user_result.data) } catch { }
                return { result: true, data: user_result.data }
            } else {
                return { result: false, error: (user_result.error) ? user_result.error : null, message: (user_result.message) ? user_result.message : null }
            }
        } catch {}
    },
    // User Data
    async ActionFetchUserData({ commit, rootState }) {
        try {
            let user_data = await axios.get("/api/personal/profile/").then(res => res.data)
            if (user_data && user_data.result && user_data.data) {
                try { await commit("setUser", user_data.data) } catch { }
                return { result: true, data: user_data.data }
            } else {
                return { result: false, error: (user_data.error) ? user_data.error : null, message: (user_data.message) ? user_data.message : null }
            }
        } catch {}
    },
    // User Wallets
    async ActionFetchUserWallets({ commit, rootState }) {
        try {
            let user_wallets = await axios.get("/api/personal/wallet/").then(res => res.data)
            if (user_wallets && user_wallets.result && user_wallets.data) {
                try { await commit("setUserWallet", user_wallets.data) } catch {}
                return { result: true, data: user_wallets.data }
            } else {
                return { result: false, error: (user_wallets.error) ? user_wallets.error : null, message: (user_wallets.message) ? user_wallets.message : null }
            }
        } catch {}
    },
    // logout
    async ActionLogout({ commit }) {
        try {
            const logout_result = await axios.get("/api/public/logout/").then(res => res.data)
            if (logout_result && logout_result.result) await commit("setLogout", null)
            return { result: true }
        } catch {}
    },
}

const mutations = {
    setUser(state, user) {
        state.user_auth = true
        state.user_name = (user.name) ? user.name : user.login
        state.user_email = (user.email) ? user.email : null
        state.user_login = (user.login) ? user.login : null
        state.user_access_codes = (user.access_codes) ? Array.from(user.access_codes) : []
        state.payment_systems = (user.payment_systems) ? Array.from(user.payment_systems) : []
    },
    setUserWallet(state, wallet) {
        state.account_details = (wallet.account_details) ? Array.from(wallet.account_details) : []
    },
    setLogout(state, user) {
        state.user_auth = false
        state.user_name = null
        state.user_email = null
        state.user_login = null
        state.user_access_codes = []
        state.payment_systems = []
        state.account_details = []
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}